<template>
  <main ref="root" class="sec-page">
    <sec-scroll-progress />
    <slot />
  </main>
</template>

<script setup>
// Root of every Secure AI Adoption view. It owns what each page needs exactly once:
// theme, hiding the global loader, GSAP scroll reveal, the smooth scroll to top on
// arrival, the scroll progress bar and the page's FAQPage structured data. (Organization and the
// rest of the page's JSON-LD are written for every route by src/router/securityHead.js.)
import '@/assets/css/security-theme.css';
import { ref, onMounted } from 'vue';
import SecScrollProgress from '@/components/security/layout/SecScrollProgress.vue';
import { useHideGlobalLoader } from '@/composables/security/useHideGlobalLoader';
import { useReveal } from '@/composables/security/useReveal';
import { useJsonLd } from '@/composables/security/useJsonLd';
import { smoothScrollToTop } from '@/composables/security/useSmoothScroll';
import { faqPageJsonLd } from '@/content/security/jsonld';

const props = defineProps({
  // FAQ items ({ q, a }) to publish as FAQPage JSON-LD for this route.
  faq: { type: Array, default: null },
});

const root = ref(null);

useHideGlobalLoader();
useReveal(root);
useJsonLd('ld-faq', props.faq ? faqPageJsonLd(props.faq) : null);

onMounted(() => {
  if (window.scrollY > 0) smoothScrollToTop();
});
</script>
